import { gsap, ScrollTrigger } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Verhaal - Galerij
 * Slug: verhaal_gallery
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.verhaal_gallery-layout');
	layouts.forEach((layout) => {
		const progress = layout.querySelector(".swiper-progress-bar");
    	const swiperContainer = layout.querySelector(".swiper-container");
    	const slideCount = swiperContainer.querySelectorAll(".swiper-slide").length;

    	return new Swiper(swiperContainer, {
			slidesPerView: 1.25,
			centeredSlides: true,
			spaceBetween: 16,
			loop: true,
			initialSlide: 1,
			breakpoints: {
				768: {
					slidesPerView: 1
				}
			},
			on: {
				init: (self) => {
					if (progress && slideCount > 1) {
						const position = (self.realIndex / (slideCount - 1)) * 80;
						gsap.set(progress, { left: `${position}%` });
					}
				},
				slideChange: (self) => {
					if (progress && slideCount > 1) {
						const position = (self.realIndex / (slideCount - 1)) * 80;
						gsap.to(progress, { left: `${position}%` });
					}
				},
				afterInit: (self) => {
					gsap.from(self.slides, {
						autoAlpha: 0,
						y: -20,
						stagger: 0.1,
						scrollTrigger: {
							trigger: layout
						}
					});
				},
			}
		});
	});
});
